/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  ActionLogDTO,
  Address,
  AddressInfoDTO,
  AddressJudgmentResult,
  AddressVerifyRequest,
  AddressVerifyResponse,
  AiCargoDTO,
  AiResultResponse,
  AllocateDTO,
  AllocateRequest,
  BatchAllocateRequest,
  BizOperRequest,
  BizOperResponse,
  CancelShipmentRequest,
  CarParamConfigDTO,
  CarrierCountDTO,
  CarrierCountResponse,
  CityDTO,
  CommissionAuditRequest,
  CompanyAddRequest,
  CompanyAuditRequest,
  CompanyDetailResponse,
  CompanyEditRequest,
  CompanyPageResponse,
  CompanyQueryRequest,
  CompanyStatusRequest,
  CreditEditRequest,
  CustomPlatformConfigPageResponse,
  CustomPlatformConfigQueryRequest,
  CustomPlatformConfigRequest,
  CustomPlatformConfigResponse,
  CustomerCreditResponse,
  CustomerFtlQuoteConfigDTO,
  CustomerQuoteConfigDTO,
  CustomerQuoteInfoDTO,
  CustomerQuoteInfoDetailDTO,
  CustomerQuoteServiceDetailDTO,
  CustomerResponse,
  DriverAddRequest,
  DriverDetailResponse,
  DriverInfoDTO,
  DriverPageResponse,
  DriverQueryRequest,
  DriverStatusRequest,
  ExceptionDealDetailResponse,
  ExceptionDealRequest,
  ExceptionDetailResponse,
  ExceptionPageResponse,
  ExceptionQueryRequest,
  FCashOutApproveRequest,
  FCashOutListResponse,
  FCashOutQueryRequest,
  FCashOutResponse,
  FCustomerWalletRequest,
  FCustomerWalletResponse,
  FHistoryBillRequest,
  FRechargeApproveRequest,
  FRechargeListResponse,
  FRechargeQueryRequest,
  FRechargeRequest,
  FRechargeResponse,
  FTradeRequest,
  FTransactionResponse,
  FWalletResponse,
  FmcsaCarrier,
  FmcsaCarrierListVO,
  FmcsaQueryRequest,
  FmcsaReamrkResponse,
  FmcsaStatusRequest,
  FreightClassRequest,
  FtlAcceptRequest,
  FtlAddStopRequest,
  FtlAddressIdDTO,
  FtlAddressResponse,
  FtlAmountDTO,
  FtlCargoDTO,
  FtlExactAddressDTO,
  FtlExactQuoteRequest,
  FtlOrderAmountRequest,
  FtlOrderAmountResponse,
  FtlOrderBackRequest,
  FtlOrderBatchIdRequest,
  FtlOrderCreateRequest,
  FtlOrderDetailExtResponse,
  FtlOrderDriverUpdateRequest,
  FtlOrderListExtResponse,
  FtlOrderPickDateRequest,
  FtlOrderPriceUpdateRequest,
  FtlOrderQueryRequest,
  FtlOrderRefNumberUpdateRequest,
  FtlOrderRemarkUpdateRequest,
  FtlQuoteConfigDTO,
  FtlQuoteConfigPageResponse,
  FtlQuoteConfigQueryRequest,
  FtlQuoteConfigRequest,
  FtlQuoteConfigResponse,
  FtlQuoteInfoDTO,
  FtlQuoteInfoDetailDTO,
  FtlQuoteResponse,
  FtlQuoteResultDTO,
  FtlRearrangeRequest,
  FtlStopFeeInfoDTO,
  FtlWaybillAllocateRequest,
  FtlWaybillAmountRecordDTO,
  FtlWaybillAmountUpdateRequest,
  FtlWaybillBolNoUpdateRequest,
  FtlWaybillDetailResponse,
  FtlWaybillListResponse,
  FtlWaybillPriceRequest,
  FtlWaybillPriceResponse,
  FtlWaybillRemarkUpdateRequest,
  FtlWaybillStatusRequest,
  FtlWaybillTrackLogResponse,
  FtlWaybillUpdateRequest,
  HelperInfoReqeust,
  IPage,
  LocalTime,
  LocalTimeReq,
  LocalTimeRes,
  MailQuoteConfigResponse,
  MainQuoteConfigPageResponse,
  MainQuoteConfigQueryRequest,
  MainQuoteConfigRequest,
  OrderAcceptRequest,
  OrderActionLogResponse,
  OrderAddressDTO,
  OrderAddressDTOReq,
  OrderAddressDTORes,
  OrderAmountRecordDTO,
  OrderAmountRequest,
  OrderAmountResponse,
  OrderBatchIdRequest,
  OrderBidPriceRequest,
  OrderCargoDTO,
  OrderCountDTO,
  OrderCountResponse,
  OrderDetailResponse,
  OrderFileRequest,
  OrderListExtResponse,
  OrderPickDateRequest,
  OrderPriceUpdateRequest,
  OrderQueryRequest,
  OrderQuoteDTO,
  OrderQuoteRequest,
  OrderQuoteResultResponse,
  OrderRefNumberUpdateRequest,
  OrderRequest,
  OrderSimpleCargoDTO,
  OrderSimpleInfoDTO,
  OrderTrackingDTO,
  OssFileResponse,
  OwnerQueryRequest,
  OwnerUserAuditRequest,
  OwnerUserEditRequest,
  OwnerUserPwdRequest,
  OwnerUserRequest,
  OwnerUserResponse,
  PageQuery,
  PlaceDetailResponse,
  PlaceResultDTO,
  PlaceResultResponse,
  PlaceSearchRequest,
  PlatformCommodityDTO,
  PlatformConfigDetailDTO,
  PlatformOrderCoreRequest,
  PlatformQuoteRateDTO,
  PlatformRateDetailDTO,
  QueryCityPageDTO,
  QueryQuoteAmountDTO,
  QuoteConfigDTO,
  QuoteConfigUpdateDTO,
  QuoteConfigUpdateRequest,
  QuoteInfoDTO,
  QuoteInfoDetailDTO,
  QuoteOrderPriceDTO,
  QuoteResultResponse,
  QuoteServiceDetailDTO,
  RouteDetailResponse,
  R,
  SalesAmountReportResponse,
  SalesCustomerRequest,
  SalesCustomerResponse,
  SalesDetailResponse,
  SalesOrderCountRequest,
  SalesOrderRequest,
  SalesOrderResponse,
  SalesQueryRequest,
  SalesSimpleResponse,
  SalesUserRequest,
  SalesUserResponse,
  SalesUserStatusVo,
  ServiceQuoteConfigRequest,
  ServiceQuoteConfigResponse,
  ServiceQuoteConfigUpdateRequest,
  ServiceQuoteDetailDTOReq,
  ServiceQuoteDetailDTORes,
  ShipmentCountResponse,
  ShipmentDetailExtResponse,
  ShipmentPageExtResponse,
  ShipmentQueryRequest,
  ShipmentTrackResponse,
  SimpleDriverListResponse,
  SimpleDriverQueryRequest,
  SimpleTruckListResponse,
  SimpleTruckQueryRequest,
  SysDepartmentTreeVo,
  SysDepartmentVo,
  SysPermission,
  SysPermissionTreeVo,
  SysPermissionVo,
  SysRoleResultVo,
  SysRoleVo,
  SysUserPasswordVo,
  SysUserQueryVo,
  SysUserStatusVo,
  SysUserVo,
  TimeZoneDTO,
  TrackInfo,
  TrackQueryRequest,
  TransferCenterQueryRequest,
  TransferCenterRequest,
  TransferCenterResponse,
  TranslateRequest,
  TranslateResponse,
  TruckAddOrEditRequest,
  TruckBindRequest,
  TruckDetailResponse,
  TruckPageQueryRequest,
  TruckPageResponse,
  TruckStatusRequest,
  UpdateBatchIdDTO,
  UpdateQuoteConfigDisableDTO,
  UserInfoVo,
  UserLoginVo,
  WaybillActionLogFileResponse,
  WaybillActionLogResponse,
  WaybillBolNoUpdateRequest,
  WaybillCountDTO,
  WaybillCountResponse,
  WaybillDetailResponse,
  WaybillFileResponse,
  WaybillPriceRecordDTO,
  WaybillPriceRequest,
  WaybillPriceResponse,
  WaybillPriceUpdateRequest,
  WaybillQueryRequest,
  WaybillRemarkUpdateRequest,
  WaybillRouteInfoDTO,
  WaybillRouteResponse,
  WaybillTrackLogResponse,
  WaybillTruckUpdateRequest,
  WaybillUpdateDriverRequest,
  WaybillUpdateRequest,
  WnChannelCommissionDTO,
} from './type';
import request from '@/utils/request';

export class WaybillService {
  // 查看司机操作日志
  public static getActiveLogUsingGET(orderNo: string): Promise<R<OrderActionLogResponse>> {
    return request('GET', '/waybill/active-log', null, { orderNo }, null, null, null);
  }

  // 分配运单
  public static allocateWaybillUsingPUT(allocateRequest: AllocateRequest): Promise<R<string>> {
    return request('PUT', '/waybill/allocate', null, null, allocateRequest, null, null);
  }

  // 批量分配运单
  public static batchAllocateWaybillUsingPUT(batchAllocateRequest: BatchAllocateRequest): Promise<R<string>> {
    return request('PUT', '/waybill/batch-allocate', null, null, batchAllocateRequest, null, null);
  }

  // 批量更新司机信息
  public static batchUpdateTruckUsingPUT(batchUpdateRequest: WaybillUpdateDriverRequest): Promise<R<string>> {
    return request('PUT', '/waybill/batchUpdateTruck', null, null, batchUpdateRequest, null, null);
  }

  // 取消运单
  public static cancelWaybillUsingPUT(orderId: number): Promise<R<string>> {
    return request('PUT', '/waybill/cancel', null, { orderId }, null, null, null);
  }

  // 运单详情
  public static detailWaybillUsingGET(orderId: number): Promise<R<WaybillDetailResponse>> {
    return request('GET', '/waybill/detail', null, { orderId }, null, null, null);
  }

  // 运单导出
  public static exportWaybillUsingPOST(query: WaybillQueryRequest): Promise<void> {
    return request('POST', '/waybill/export', null, null, query, null, null);
  }

  // 运单列表
  public static pageWaybillUsingPOST(query: WaybillQueryRequest): Promise<R<IPage<OrderListExtResponse>>> {
    return request('POST', '/waybill/page', null, null, query, null, null);
  }

  // 查看路由
  public static getWaybillRouteInfoUsingGET(orderId: number): Promise<R<RouteDetailResponse>> {
    return request('GET', '/waybill/routeDetail', null, { orderId }, null, null, null);
  }

  // 查看轨迹坐标
  public static getTrackingLocationUsingGET(orderNo: string, latestId?: number): Promise<R<Array<OrderTrackingDTO>>> {
    return request('GET', '/waybill/tracking-location', null, { latestId, orderNo }, null, null, null);
  }

  // 查看轨迹
  public static getWaybillTrackingLogUsingGET(orderNo: string): Promise<R<WaybillTrackLogResponse>> {
    return request('GET', '/waybill/tracking-log', null, { orderNo }, null, null, null);
  }

  // 查看操作留痕文件
  public static getWaybillTrackingLogFileUsingGET(actionId: number): Promise<R<WaybillActionLogFileResponse>> {
    return request('GET', '/waybill/tracking-logFile', null, { actionId }, null, null, null);
  }

  // 更新运单
  public static updateWaybillUsingPUT(updateRequest: WaybillUpdateRequest): Promise<R<string>> {
    return request('PUT', '/waybill/update', null, null, updateRequest, null, null);
  }

  // 更新bol单号
  public static updateBolNoUsingPUT(updateRequest: WaybillBolNoUpdateRequest): Promise<R<string>> {
    return request('PUT', '/waybill/updateBolNo', null, null, updateRequest, null, null);
  }

  // 新增/更新订单备注
  public static updateWaybillRemarkUsingPUT(updateRequest: WaybillRemarkUpdateRequest): Promise<R<string>> {
    return request('PUT', '/waybill/updateRemark', null, null, updateRequest, null, null);
  }

  // 更新运费
  public static updateWaybillPriceUsingPUT(updateRequest: WaybillPriceUpdateRequest): Promise<R<string>> {
    return request('PUT', '/waybill/updateWaybillPrice', null, null, updateRequest, null, null);
  }

  // 更新司机信息
  public static updateTruckUsingPUT(updateRequest: WaybillTruckUpdateRequest): Promise<R<string>> {
    return request('PUT', '/waybill/updateWaybillTruck', null, null, updateRequest, null, null);
  }

  // 列表数量统计
  public static waybillStatusCountUsingPOST(query: WaybillQueryRequest): Promise<R<WaybillCountResponse>> {
    return request('POST', '/waybill/waybillStatus', null, null, query, null, null);
  }
}
